import { render } from "./documents.vue?vue&type=template&id=ac5d8f3c&scoped=true"
import script from "./documents.vue?vue&type=script&lang=ts"
export * from "./documents.vue?vue&type=script&lang=ts"

import "./documents.vue?vue&type=style&index=0&id=ac5d8f3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ac5d8f3c"

export default script